module.exports = __webpack_public_path__ + "static/media/blurbDefault.7cb49d3f.svg";